import React from 'react';
import KorshaLogo from './KorshaLogo';

const NAV_LINKS = ['Home', 'About', 'Projects', 'Skills', 'Team', 'Contact'];

const PROJECTS_LINKS = [
  { label: 'DQ Coffee ↗', url: 'https://dqcoffee.in' },
  { label: 'Habitat Tracker ↗', url: 'https://korshahabitattracker.vercel.app/' },
];

const Footer = ({ navTo }) => {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <div className="footer-inner">
          {/* Brand column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <KorshaLogo size={30} />
              <span className="footer-logo-text">KORSHA</span>
            </div>
            <p className="footer-tagline-text">The Future, Drawn to You.</p>
            <p className="footer-desc">
              End-to-end digital products — design systems to cloud deployments.
              Built by Suresh Narasimman, powered by purpose.
            </p>
            <div className="footer-socials">
              <a href="mailto:sureshsimmar@gmail.com" className="social-btn" title="Email">✉</a>
              <a href="https://korsha.ai" target="_blank" rel="noreferrer" className="social-btn" title="Website">🌐</a>
              <a href="https://www.linkedin.com/in/suresh-narasimman-r-9a1850a8/" target="_blank" rel="noreferrer" className="social-btn" title="LinkedIn">in</a>
            </div>
          </div>

          {/* Navigate column */}
          <div>
            <div className="footer-col-title">Navigate</div>
            <ul className="footer-links-list">
              {NAV_LINKS.map(link => (
                <li key={link}>
                  <button className="footer-link" onClick={() => navTo(link.toLowerCase())}>
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Projects column */}
          <div>
            <div className="footer-col-title">Projects</div>
            <ul className="footer-links-list">
              {PROJECTS_LINKS.map(({ label, url }) => (
                <li key={label}>
                  <a href={url} target="_blank" rel="noreferrer" className="footer-link">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <div className="footer-col-title">Get in Touch</div>
            <a href="mailto:sureshsimmar@gmail.com" className="footer-link">
              sureshsimmar@gmail.com
            </a>
            <div className="footer-avail">
              <span className="avail-dot" />
              Open to new projects
            </div>
            <button
              className="btn-primary"
              onClick={() => navTo('contact')}
              style={{ fontSize: '.82rem', padding: '11px 24px', display: 'inline-flex' }}
            >
              Start a Project
            </button>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span className="footer-copy">
            © {year} Korsha · Suresh Narasimman. Built with{' '}
            <span style={{ color: '#8A6BC4' }}>♥</span>
          </span>
          <span className="footer-sub">KORSHA.AI · THE FUTURE, DRAWN TO YOU.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
